var map = {
	"./DialogService": 17,
	"./DialogService.js": 17,
	"./addPeriodicDownloadDialog.tpl.html": 472,
	"./advertisingSettingsTemplate.tpl.html": 932,
	"./bonusShopDialog.tpl.html": 473,
	"./confirmChangeDialog.tpl.html": 474,
	"./confirmTANSMSDialog.tpl.html": 475,
	"./demoUserDialog.tpl.html": 476,
	"./downloadDialog.tpl.html": 477,
	"./emailDialog.tpl.html": 478,
	"./errorTemplate.tpl.html": 479,
	"./fakeTemplate.tpl.html": 933,
	"./firstLoginDialog.tpl.html": 480,
	"./index": 181,
	"./index.js": 181,
	"./infoDialog.tpl.html": 481,
	"./inputDialog.tpl.html": 482,
	"./kycAdminActionConfirmationDialog.tpl.html": 483,
	"./kycAdminStatusHistoryDialog.tpl.html": 484,
	"./kycJumpDialog.tpl.html": 485,
	"./kycSubmitDialog.tpl.html": 486,
	"./notificationTemplate.tpl.html": 487,
	"./primaryTemplate.tpl.html": 488,
	"./protectBuyTemplate.tpl.html": 489,
	"./sSMSDialog.tpl.html": 490,
	"./securityQuestionTemplate.tpl.html": 934,
	"./settingsTemplate.tpl.html": 935,
	"./storedFilterDeleteDialog.tpl.html": 491,
	"./storedFilterDialog.tpl.html": 492,
	"./verifyContractsDialog.tpl.html": 493,
	"./welcomeDialog.tpl.html": 494,
	"./windowTemplate.tpl.html": 936,
	"./windowTemplateError.tpl.html": 937,
	"./windowTemplateNotification.tpl.html": 938,
	"./windowTemplateNotificationXLarge.tpl.html": 939,
	"./windowTemplateNotificationXXLarge.tpl.html": 940,
	"./windowTemplatePrimary.tpl.html": 941
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 601;



//////////////////
// WEBPACK FOOTER
// ./src/ui/modules/dc-ui/dc-modal ^\.\/.*$
// module id = 601
// module chunks = 12